import { useContext } from "react";
import { AppContext } from "../App";
import { services } from "./ServicesContent";

export default function HomeServicesContent() {
  const appContext = useContext(AppContext);

  return (
    <section className="section-shell section-soft">
      <div className="container">
        <div className="section-heading-row">
          <div>
            <h2 data-aos="fade-right" data-aos-delay="100">Built to serve modern households, offices, and institutions.</h2>
            <p data-aos="fade-up" data-aos-delay="200">
              Our service portfolio combines product importation and supply with
              premium cleaning support, giving clients one dependable partner
              across everyday operational needs.
            </p>
          </div>

          <button
            className="btn btn-outline-primary"
            onClick={() => appContext.navTo({ item: "services" })}
          >
            View All Services
          </button>
        </div>

        <div className="row g-4">
          {services.slice(0, 4).map((service, index) => (
            <div key={service.slug} className="col-md-6 col-xl-3">
              <button
                className="service-card text-start h-100 w-100 "
                data-aos="fade-up" data-aos-delay={index * 150}
                onClick={() =>
                  appContext.navTo({ item: "services", subItem: service.slug })
                }
              >
                <img style={{top: 0}} src={service.image} alt={service.title} className="service-card-image" />
                <div className="service-card-body d-flex flex-column p-2 gap-2">
                  <h3>{service.title}</h3>
                  <p>{service.shortDescription}</p>
                  <span className="service-card-link flex-grow-1 align-self-start">Explore Service</span>
                </div>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
